import { Country } from '@/domainLogic/index.ts';

import { DISTANCE_UNITS, WEIGHT_UNITS } from '@/app/common/measures/types.ts';

export const getDistanceUnit = (country: Country): DISTANCE_UNITS => {
  switch (country) {
    case Country.US:
    case Country.GB:
      return DISTANCE_UNITS.MI;
    default:
      return DISTANCE_UNITS.KM;
  }
};

export const getShortDistanceUnit = (country: Country): DISTANCE_UNITS => {
  switch (country) {
    case Country.US:
    case Country.GB:
      return DISTANCE_UNITS.FT;
    default:
      return DISTANCE_UNITS.M;
  }
};

export const getWeightUnit = (country: Country): WEIGHT_UNITS => {
  switch (country) {
    case Country.US:
      return WEIGHT_UNITS.LBS;
    default:
      return WEIGHT_UNITS.KG;
  }
};
